import React from 'react'
import { LookupServieURL } from "../../../config/config";
import { useEffect, useState } from "react";
import { postApiCall } from "../../../services/apiHelper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  TextField,
  CircularProgress,
  Autocomplete,
  Checkbox
} from "@mui/material";
import Button from "@mui/material/Button";
import { useParams, useNavigate } from 'react-router-dom';
import { ServiceName } from '../../../constants';
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";
import { wait } from '@testing-library/user-event/dist/utils';
import { ToastMessage } from "../../util/ToastMessage";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const AppraiserFirmNewForm = () => {


  const RegionOptions = [
    { label: 'US', value: 'US' },
    { label: 'EMEA', value: 'EMEA' },
    { label: 'APAC', value: 'APAC' }

  ];
  const region = React.useRef("");
  const [regionList, setRegionList] = useState<any[]>(RegionOptions);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const [name, setName] = React.useState('');
  const [appraisalfirm, setAppraisalFirm] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [errored, setErrored] = React.useState(false);
  const [emailErrored, setEmailErrored] = React.useState(false);

  const Validate = () => {
    if (!name || !appraisalfirm || !region.current) {
      return true
    }
    else {
      return false;
    }

  }


  const ValidateEmail = () => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email) {
      let isValidEmail = pattern.test(email);
      if (isValidEmail) {
        setEmailErrored(false);
        return false;
      }
      else {
        setEmailErrored(true);
        return true;
      }
    }
    else {
      setEmailErrored(true);
      return true;
    }
  }

  const handelRegionChange = (regions: any) => {
    setSelectedRegion(
      regions.sort((a: any, b: any) => a.value.localeCompare(b.value)).reverse()
    );
  }

  const handelEmailChange = (event: any) => {

    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmail(event.target.value);
    let isValidEmail = pattern.test(email);
    if (isValidEmail) {
      setEmailErrored(false);
    }
    else {
      setEmailErrored(true);
    }
  }


  const Add = () => {
    let regionselected = selectedRegion.map((region) => region.label).join(";");
    region.current = regionselected;
    let error = true;
    let isEmailValid = ValidateEmail();
    error = Validate();
    if (!error) {
      error = isEmailValid;
    }
    setErrored(error);
    if (!error) {
      try {
        setTimeout(() => {
          setLoading(true);
        }, 1000);
        let curDT = new Date();
        const AppraiserFirm = {
          name: name,
          appraisalFirm: appraisalfirm,
          email: email,
          status: "Active",
          createdBy: currentUserData.email,
          created: curDT,
          lastModifiedBy: currentUserData.email,
          lastModified: curDT,
          region: regionselected
        }

        var url = LookupServieURL + "/externalappraisers/save";
        postApiCall(url, AppraiserFirm, ServiceName.LOOKUPSERVICE)
          .then((res: any) => {
            setIsSuccess(true);
            wait(3000).then(() => {
              navigate("/appraiserfirm/list");
            });
          })
          .catch((error: any) => {
            setIsError({
              isError: true,
              message: "Error Occurred While Submit",
            });

          });
      }
      catch (error) {
        console.log(error);
      } finally {
        wait(1000).then(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
      }
    }
    setIsError({ isError: false, message: "" });
    setIsSuccess(false);


  };

  const RedirectToDashboard = () => {
    navigate("/appraiserfirm/list");
  };

  return (
    <div className="form-wrap">
      {loading && (
        <div className="overlaySpinner">
          <CircularProgress />
        </div>
      )}
      {isSuccess && (
        <ToastMessage message="User Role map is submitted" severity="success" />
      )}
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <TextField
              required
              InputLabelProps={{
                sx: {
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                },
              }}
              id="outlined-External-Appraiser"
              label="External Appraiser Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              helperText={!name && errored ? "Name is required" : ""}
              error={!name && errored}
              size="small"
              fullWidth
            />
          </Grid><Grid item xs={6} sm={6}>
            <TextField
              required
              InputLabelProps={{
                sx: {
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                },
              }}
              id="outlined-appraisalFirm"
              label="Appraiser Firm"
              defaultValue={appraisalfirm}
              onChange={(e) => setAppraisalFirm(e.target.value)}
              helperText={!appraisalfirm && errored ? "Appraiser Firm is required" : ""}
              error={!appraisalfirm && errored}
              size="small"
              fullWidth
            />
          </Grid><Grid item xs={6} sm={6}>
            <TextField
              required
              InputLabelProps={{
                sx: {
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                },
              }}
              id="outlined-email"
              label="Email Address"
              defaultValue={email}
              onChange={(e) => {
                handelEmailChange(e);
              }}
              helperText={emailErrored ? "Email is required & should be in correct Email format" : ""}
              error={emailErrored}
              size="small"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Autocomplete
              multiple
              aria-label="Region_test"
              id="checkboxes-tags-demo"
              options={regionList}
              value={selectedRegion}
              disableCloseOnSelect
              getOptionLabel={(option) => option.label}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
              onChange={(event, value) => {
                handelRegionChange(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Region"
                  size="small"
                  error={selectedRegion.length == 0 && errored}
                  helperText={selectedRegion.length == 0 && errored ? "Region is required" : ""}
                  placeholder="Selece region"
                  required
                  InputLabelProps={{
                    sx: {
                      '& .MuiInputLabel-asterisk': {
                        color: 'red',
                      },
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Button sx={{ textTransform: "none", ml: 2 }} onClick={() => Add()} variant="contained" disabled={isSuccess} size="medium" color="success">Submit</Button>
            <Button sx={{ textTransform: "none", ml: 2 }} variant="contained" size="medium" color="error"
              onClick={RedirectToDashboard}>Cancel</Button>
          </Grid>

        </Grid></Box>
    </div>
  )
};
